<ng-template cdkPortal #actions="cdkPortal">
  <label class="btn btn-icon btn-secondary">
    <icon-plus></icon-plus>
    <span class="ml-2">
      <ng-container *ngIf="!fileInWay">Upload&nbsp;</ng-container>
      <ng-container *ngIf="fileInWay">Loading</ng-container>
    </span>
    <input type="file" hidden (change)="upload($event)">
  </label>
</ng-template>

<ul class="library-list m-0 p-0">
  <li class="library-list__item py-2 px-0" *ngFor="let item of items; let index = index">
    <div class="library-list__name">{{ index + 1 }}. {{ item.name }}</div>
    <button class="library-list__copy small " (click)="copy($event, item)">
      <span class="text-primary border-dotted">
        <ng-container *ngIf="item.copied">Copied</ng-container>
        <ng-container *ngIf="!item.copied">Copy</ng-container>
      </span>
      <input class="library-list__invisible" [value]="item.Location">
    </button>
    <div class="library-list__link small cursor-pointer border-dotted" (click)="openModal()">{{ item.Location }}</div>
    <div class="small text-grey">{{ item.createdAt | moment }}</div>
  </li>
</ul>
